import React, { useEffect } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import LicenseSurveyForm from '../../Property/LicenseySurvey/LicenseSurveyForm';

export default function PropertyLicenseSurveyPage({
	create_business_license_survey_endpoint,
	get_business_license_survey_by_property_endpoint,
	update_business_license_survey_endpoint,
	create_business_license_application_endpoint
}) {
	let { id } = useParams();

	const location = useLocation();
	const propertyName = location.state ? location.state.propertyName : '';
	const isEditing = location.state ? location.state.isEditing : '';

	useEffect(
		() => {
			// console.log('Received propertyName:', propertyName);
		},
		[
			propertyName
		]
	);

	return (
		<div>
			<div className="-mt-8 md:-mt-12 mb-8 md:mb-12 md:text-xl">
				<Link to="/dashboard" className="hover:underline mr-2 md:mr-3">
					Dashboard
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
				<Link to={`/properties/${id}`} className="hover:underline mr-2 md:mr-3">
					{propertyName || 'Property Name'}
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
			</div>
			<LicenseSurveyForm
				propertyId={id}
				propertyName={propertyName}
				isEditing={isEditing}
				create_business_license_survey_endpoint={
					create_business_license_survey_endpoint
				}
				get_business_license_survey_by_property_endpoint={
					get_business_license_survey_by_property_endpoint
				}
				update_business_license_survey_endpoint={
					update_business_license_survey_endpoint
				}
				create_business_license_application_endpoint={
					create_business_license_application_endpoint
				}
			/>
		</div>
	);
}

PropertyLicenseSurveyPage.propTypes = {
	create_business_license_survey_endpoint: PropTypes.string.isRequired,
	get_business_license_survey_by_property_endpoint: PropTypes.string.isRequired,
	update_business_license_survey_endpoint: PropTypes.string.isRequired,
	create_business_license_application_endpoint: PropTypes.string.isRequired
};
